import { v4 as uuidv4 } from 'uuid';

import { CHECK_DEPOSIT_STEPS } from '#client/constants/checkDeposit';

import { MODAL_ACTION } from '../constants/actions';

export const initState = () => {
  const depositInitData = {
    title: 'Check deposit',
    loading: false,
    currentFormStep: CHECK_DEPOSIT_STEPS.EDUCATION,
    submittedData: {},
    idempotencyKey: '',
    amount: 0,
    frontImage: null,
    backImage: null,
    confirmationNumber: null
  };

  return Object.defineProperty(depositInitData, 'idempotencyKey', {
    value: uuidv4(),
    writable: false,
    enumerable: true
  });
};

export const depositReducer = (state, action) => {
  switch (action.type) {
    case MODAL_ACTION.DEPOSIT_ANOTHER:
      return {
        ...initState(),
        currentFormStep: CHECK_DEPOSIT_STEPS.OVERVIEW
      };
    case MODAL_ACTION.START_LOADING:
      return {
        ...state,
        title: '',
        loading: true,
        ...action.payload
      };
    case MODAL_ACTION.STOP_LOADING:
      return {
        ...state,
        title: 'Check deposit',
        loading: false
      };
    case MODAL_ACTION.GO_SUBMISSION_OVERVIEW:
      return {
        ...state,
        currentFormStep: CHECK_DEPOSIT_STEPS.SUBMISSION,
        ...action.payload
      };
    case MODAL_ACTION.GO_OVERVIEW:
      return {
        ...state,
        currentFormStep: CHECK_DEPOSIT_STEPS.OVERVIEW,
        ...action.payload
      };
    default:
      return state;
  }
};
